import { SystemUserRoles, type SystemUserRolesType } from '@/api/types/Organization'
import useAuthStore from '@/stores/authStore'
import { formatAsTitle } from '@/utils/format'
import { colors } from '@/utils/theme'

const SystemUserRoleDetails = SystemUserRoles.map(role => {
  const formattedRole = formatAsTitle(role)
  return {
    role,
    name: formattedRole,
    color: (() => {
      switch (role) {
        case 'ORG_LEAD':
          return colors['primary']
        case 'ADMIN':
          return colors['blue']
        case 'DELEGATE':
          return colors['teal']
        case 'INNER_CIRCLE':
          return colors['orange']
        case 'INDIVIDUAL':
        default:
          return colors['black-light-40']
      }
    })()
  }
})

const useRoles = () => {
  const { user, currentOrganization } = useAuthStore()

  const role = currentOrganization?.roles[0]
  const roleDetails = SystemUserRoleDetails.find(r => r.role === role)

  return {
    isAdmin: role === SystemUserRoles.find(r => r === 'ADMIN'),
    // isOrgLead: role === SystemUserRoles.find(r => r === 'ORG_LEAD'),
    isDelegate: role === SystemUserRoles.find(r => r === 'DELEGATE'),
    isInnerCircle: role === SystemUserRoles.find(r => r === 'INNER_CIRCLE'),
    isSubject: role === SystemUserRoles.find(r => r === 'INDIVIDUAL'),
    isSuperAdmin: user?.isSuperAdmin,
    role: role as SystemUserRolesType,
    roleName: roleDetails?.name,
    roleColor: roleDetails?.color,
    getRoleName: (r: SystemUserRolesType) => {
      const details = SystemUserRoleDetails.find(roleDetail => roleDetail.role === r)
      return details?.name ?? formatAsTitle(r)
    },
    getRoleColor: (r: SystemUserRolesType) => {
      const details = SystemUserRoleDetails.find(roleDetail => roleDetail.role === r)
      return details?.color ?? undefined
    }
  }
}

export default useRoles
